import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { LinkIcon, CheckIcon } from "./icons";
import { BonusBalanceProps } from "./types";

const DEFAULT_DESCRIPTION =
  "Earn 3% from your invited users spending - automatically, every month";

/**
 * Bonus-balance card (Figma 568:75373). Pure presentational: caption + amount
 * + referral-link button + description, and a footer (credit date / earned
 * all-time). White card surface flips in dark.
 */
export const BonusBalance: React.FC<BonusBalanceProps> = ({
  amount,
  earnedAllTime,
  creditDate,
  description = DEFAULT_DESCRIPTION,
  linkLabel = "Referral link",
  copied = false,
  onCopyLink,
  className,
}) => {
  // "1,530" + ".00" — comma thousands in the int part, matching Figma.
  const [rawDollars, cents] = Math.abs(amount).toFixed(2).split(".");
  const dollars = Number(rawDollars).toLocaleString("en-US");

  return (
    <div className={cs(styles.card, className)}>
      <div className={styles.top}>
        <div className={styles.info}>
          <p className={styles.caption}>Bonus balance:</p>
          <p className={styles.amount}>
            <span className={styles.currency}>$</span>
            <span className={styles.dollars}>{dollars}</span>
            <span className={styles.cents}>.{cents}</span>
          </p>
        </div>
        <div className={styles.aside}>
          <button type="button" className={styles.linkBtn} onClick={onCopyLink}>
            {linkLabel}
            {copied ? (
              <CheckIcon className={styles.linkIcon} />
            ) : (
              <LinkIcon className={styles.linkIcon} />
            )}
          </button>
          <p className={styles.description}>{description}</p>
        </div>
      </div>

      <div className={styles.footer}>
        <p className={styles.footText}>To be credited on {creditDate}</p>
        <div className={styles.earned}>
          <span className={styles.footText}>Earned in all time:</span>
          <span className={styles.earnedValue}>{earnedAllTime}</span>
        </div>
      </div>
    </div>
  );
};

export default BonusBalance;
